// extracted by mini-css-extract-plugin
export var blockItem__img = "screen3-module--block-item__img--4e90e";
export var blockItem__text = "screen3-module--block-item__text--bdf43";
export var screen3 = "screen3-module--screen3--fe78d";
export var screen3__block = "screen3-module--screen3__block--a0b33";
export var screen3__blockItem = "screen3-module--screen3__block-item--e9161";
export var screen3__title = "screen3-module--screen3__title--ed91e";